<template>
  <b-row class="justify-content-center m-0" align-v="center" :style="{ height: '100%' }">
    <div>
      <b-row class="box-content">
        <b-col class="box-content__left">
          <div class="content">
            <div class="mb-u6 text__title">
              <h3><b>Your email has been verified!</b></h3>
            </div>
            <span class="text__description">Your email address has been change to </span>
            <span class="text__email text-primary" variant="primary">{{ email }}</span>
            <div class="button__back">
              <b-button
                ref="go-to-signin"
                variant="primary"
                class="mt-u6"
                style="width: 200px"
                @click="goToSignIn"
              >
                Go to sign in page</b-button
              >
            </div>
          </div>
        </b-col>
        <b-col cols="6" class="box-content__right">
          <b-img class="img-right" :src="require(`@/assets/letter-email.jpg`)" />
        </b-col>
      </b-row>
    </div>
  </b-row>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      required: true
    }
  },
  methods: {
    async goToSignIn() {
      this.$router.push({ name: 'SignIn' });
    }
  }
};
</script>

<style lang="scss" scoped>
.text__title {
  font-weight: 700;
  font-size: 26.6px;
  line-height: 32px;
  color: #3b3e66;
}

.text__description {
  font-weight: 400;
  font-size: 15.2px;
  line-height: 22px;
  color: #3b3e66;
}
.text__email {
  font-weight: 400;
  font-size: 15.2px;
  line-height: 22px;
}
.box-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 50px 10px;
  padding: 5%;
}
.box-content__right .img-right {
  max-width: 500px;
}
.img-right {
  max-width: 300px;
}
@media only screen and (max-width: 767px) {
  .box-content {
    flex-direction: column-reverse;
    gap: 20px 25px;
  }
  .box-content__right {
    min-width: 300px;
    width: 80%;
  }
  .img-right {
    width: 100%;
  }
  .box-content__left {
    align-items: center;
    min-width: 250px;
    width: 80%;
  }
  .content {
    text-align: center;
  }
  .button__back {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .box-content {
    gap: 50px 0;
  }
  .box-content__right .img-right {
    min-width: 250px;
    width: 100%;
  }
}
</style>
